// extracted by mini-css-extract-plugin
export default {"headerNavContainer":"headerNav_headerNavContainer__3ciCF","logo":"headerNav_logo__saUWM"};